import React from 'react';
import styled from 'styled-components';
import OutbrainAds from '../components/OutbrainAds';

const PageContainer = styled.div`
  min-height: 100vh;
  background: var(--white);
  padding: var(--space-8);
  
  @media (max-width: 768px) {
    padding: var(--space-4);
  }
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const ExploreMore: React.FC = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <OutbrainAds type="footer" />
        <OutbrainAds type="longscroll" />
      </ContentWrapper>
    </PageContainer>
  );
};

export default ExploreMore;

